/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { NotAvailable } from '@/components/blocks/NotAvailable';
import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { Category } from '@/components/content/Category';
import { useChildCategoryGrid } from '@/data/Content/ChildCategoryGrid';
import { useLocalization } from '@/data/Localization';
import { ID } from '@/data/types/Basic';
import { Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';

export const ChildCategoryGrid: FC<{ id: ID }> = ({ id }) => {
	const { root, categories, loading } = useChildCategoryGrid(id);
	const { notAvailable } = useLocalization('Category');

	const theme = useTheme();
	const isMqMd = useMediaQuery(theme.breakpoints.up('md'));

	return !loading && !root ? (
		<NotAvailable message={notAvailable.t()} />
	) : categories?.length ? (
		loading ? (
			<ProgressIndicator />
		) : isMqMd ? (
			<Stack spacing={2} direction={'row'} flexWrap="nowrap">
				{categories.map(({ uniqueID: catId }) => (
					<Category id={catId} key={catId} />
				))}
			</Stack>
		) : (
			<Grid container spacing={2}>
				{categories.map(({ uniqueID: catId }) => (
					<Category id={catId} key={catId} />
				))}
			</Grid>
		)
	) : null;
};
